import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  :global(.Modal__content) {
    max-width: 430px;
  }

  .InvestWithdrawForm {
    &__btns {
      display: flex;
      justify-content: space-between;

      :global(.DefaultButton) {
        width: 48%;
      }
    }

    :global(.RadioButton) {
      margin-top: 20px;
    }

    &__innerField {
      padding-left: 20px;
    }

    &__desc {
      color: #777777;
      font-size: rem(12px);
      margin-top: -10px;
      margin-bottom: 25px;
      white-space: pre-line;

      :global(.MoneyCell__inner) {
        display: inline-block;
        height: auto;
        margin-left: 5px;

        :global(span) {
          color: #777777 !important;
          font-size: rem(12px) !important;
          font-weight: 500;
        }
      }
    }

    &__sub {
      padding-left: 30px;
      margin-top: 10px;
      font-size: rem(12px);
    }

    &__error {
      color: #e33046;
      padding-left: 30px;
      margin-top: 10px;
      font-size: rem(12px);

      :global(.DefaultButton) {
        text-transform: capitalize;
        font-weight: 400;
        font-size: rem(12px);
        text-decoration: underline;
      }
    }

    &__field {
      padding-left: 30px;
      margin-top: 10px;
    }

    :global(.formError) {
      margin-bottom: 10px;
    }
  }
`;

export default staticStyles;
